// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.90.0-beta.5c31b1cf7',
  revision: '5c31b1cf7',
  branch: 'develop',
  date: 'Wed, 05 Aug 2026 20:42:56 GMT'
};